import React, {
  createContext,
  useCallback,
  useContext,
  useEffect,
  useMemo,
  useState,
} from 'react';
import PropTypes from 'prop-types';
import { fetchGenerica49Apps, itemSoloEstudiante } from './inicioAppsShared';
import { PERFILES_ESTUDIANTE } from '../bienestar_estudiantil/helper';

const InicioAppsContext = createContext({
  items: [],
  cargado: false,
  recargar: () => {},
});

export function InicioAppsProvider({ activo, perfilCodigo, children }) {
  const [items, setItems] = useState([]);
  const [cargado, setCargado] = useState(false);

  const esEstudiante = PERFILES_ESTUDIANTE.includes(perfilCodigo);

  const recargar = useCallback(async () => {
    if (!activo) {
      setItems([]);
      setCargado(true);
      return;
    }
    setCargado(false);
    try {
      const data = await fetchGenerica49Apps();
      const filtrados = data.filter(
        (it) => !itemSoloEstudiante(it) || esEstudiante
      );
      setItems(filtrados);
    } catch {
      setItems([]);
    } finally {
      setCargado(true);
    }
  }, [activo, esEstudiante]);

  useEffect(() => {
    recargar();
  }, [recargar]);

  const value = useMemo(
    () => ({ items, cargado, recargar }),
    [items, cargado, recargar]
  );

  return (
    <InicioAppsContext.Provider value={value}>
      {children}
    </InicioAppsContext.Provider>
  );
}

InicioAppsProvider.propTypes = {
  activo: PropTypes.bool,
  perfilCodigo: PropTypes.string,
  children: PropTypes.node,
};

InicioAppsProvider.defaultProps = {
  activo: true,
  perfilCodigo: '',
};

export function useInicioApps() {
  return useContext(InicioAppsContext);
}
